(function () {
  function formatMoney(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents, window.themeVariables.settings.moneyFormat);
    }

    return '$' + (cents / 100).toFixed(2);
  }

  function parseMoneyFromTitle(title) {
    var match = String(title || '').replace(/,/g, '').match(/([\d.]+)/);
    return match ? Math.round(parseFloat(match[1]) * 100) : 0;
  }

  function getVariantThresholdEntries(variants) {
    return variants.map(function (variant, index) {
      var title = String(variant.title || '').trim();
      var threshold = parseMoneyFromTitle(title);
      var type = null;

      if (title.indexOf('<') !== -1) {
        type = 'lessThan';
      } else if (title.indexOf('+') !== -1) {
        type = 'greaterEqual';
      }

      return {
        variant: variant,
        threshold: threshold,
        type: type,
        index: index
      };
    }).filter(function (entry) {
      return entry.type && entry.threshold > 0;
    });
  }

  function getHighestPriceVariant(variants) {
    return variants.reduce(function (highest, variant) {
      if (!highest || (variant.price || 0) > (highest.price || 0)) {
        return variant;
      }

      return highest;
    }, null);
  }

  function findProtectionVariant(cartTotalCents, variants) {
    if (!variants || !variants.length) {
      return null;
    }

    var entries = getVariantThresholdEntries(variants);
    var lessThanEntries = entries.filter(function (entry) {
      return entry.type === 'lessThan';
    });
    var greaterEqualEntries = entries.filter(function (entry) {
      return entry.type === 'greaterEqual';
    });
    var allThresholds = entries.map(function (entry) {
      return entry.threshold;
    });
    var maxThreshold = allThresholds.length ? Math.max.apply(null, allThresholds) : 0;
    var i;
    var matchedPlus = null;
    var matchedPlusThreshold = -1;

    for (i = 0; i < lessThanEntries.length; i++) {
      if (cartTotalCents < lessThanEntries[i].threshold) {
        return lessThanEntries[i].variant;
      }
    }

    for (i = 0; i < greaterEqualEntries.length; i++) {
      if (cartTotalCents >= greaterEqualEntries[i].threshold && greaterEqualEntries[i].threshold >= matchedPlusThreshold) {
        matchedPlus = greaterEqualEntries[i].variant;
        matchedPlusThreshold = greaterEqualEntries[i].threshold;
      }
    }

    if (matchedPlus) {
      return matchedPlus;
    }

    if (allThresholds.length && cartTotalCents > maxThreshold) {
      return getHighestPriceVariant(variants);
    }

    return variants.find(function (variant) {
      return variant.available;
    }) || variants[0];
  }

  function getProtectionConfig(drawer) {
    var configNode = drawer.querySelector('[data-protection-config]');

    if (!configNode) {
      return null;
    }

    try {
      return JSON.parse(configNode.textContent);
    } catch (error) {
      return null;
    }
  }

  function setProtectionBlockLoading(drawer, isLoading) {
    var protectionRow = drawer ? drawer.querySelector('[data-protection-row]') : null;

    if (protectionRow) {
      protectionRow.classList.toggle('mini-cart__protection--loading', isLoading);
    }
  }

  var removingLoneProtection = false;
  var syncingProtection = false;

  function getProtectionProductId() {
    return window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.protectionProductId;
  }

  function getCartTotalForProtection(cart, protectionProductId) {
    if (!cart) {
      return 0;
    }

    var total = cart.total_price || 0;

    if (!protectionProductId || !cart.items) {
      return total;
    }

    cart.items.forEach(function (item) {
      if (item.product_id === protectionProductId) {
        total -= item.final_line_price;
      }
    });

    return total;
  }

  function getProtectionLineFromCart(cart, protectionProductId) {
    if (!cart || !cart.items || !protectionProductId) {
      return null;
    }

    for (var i = 0; i < cart.items.length; i++) {
      if (cart.items[i].product_id === protectionProductId) {
        return {
          item: cart.items[i],
          lineIndex: i + 1
        };
      }
    }

    return null;
  }

  function updateProtectionBlockData(drawer, cartTotalForProtection, protectionLine, targetVariant) {
    var configNode = drawer ? drawer.querySelector('[data-protection-config]') : null;
    var priceNode = drawer ? drawer.querySelector('[data-protection-price]') : null;
    var toggle = drawer ? drawer.querySelector('[data-protection-toggle]') : null;
    var config = getProtectionConfig(drawer);

    if (!drawer || !configNode || !config) {
      return;
    }

    config.cartTotal = cartTotalForProtection;
    config.enabled = !!protectionLine;
    config.lineIndex = protectionLine ? protectionLine.lineIndex : null;
    configNode.textContent = JSON.stringify(config);

    if (priceNode && targetVariant) {
      priceNode.textContent = formatMoney(
        protectionLine ? protectionLine.item.final_line_price : targetVariant.price
      );
    }

    if (toggle) {
      toggle.checked = !!protectionLine;
    }
  }

  async function replaceProtectionInCart(lineIndex, variantId) {
    await removeProtectionLine(lineIndex);
    return addProtectionVariant(variantId);
  }

  async function syncProtectionBeforeRender(cartContent, drawer, options) {
    if ((options && options.skipProtectionSync) || syncingProtection) {
      return cartContent;
    }

    var protectionProductId = getProtectionProductId();

    if (!protectionProductId || !cartContent || !cartContent.items) {
      return cartContent;
    }

    drawer = drawer || document.getElementById('mini-cart');
    var config = getProtectionConfig(drawer);

    if (!config || !Array.isArray(config.variants) || !config.variants.length) {
      return cartContent;
    }

    var cartTotalForProtection = getCartTotalForProtection(cartContent, protectionProductId);
    var protectionLine = getProtectionLineFromCart(cartContent, protectionProductId);
    var targetVariant = findProtectionVariant(cartTotalForProtection, config.variants);

    if (!targetVariant) {
      updateProtectionBlockData(drawer, cartTotalForProtection, protectionLine, null);
      return cartContent;
    }

    updateProtectionBlockData(drawer, cartTotalForProtection, protectionLine, targetVariant);

    if (!protectionLine || protectionLine.item.variant_id === targetVariant.id) {
      return cartContent;
    }

    if (!targetVariant.available) {
      return cartContent;
    }

    syncingProtection = true;

    try {
      var updatedCart = await replaceProtectionInCart(protectionLine.lineIndex, targetVariant.id);
      var updatedProtectionLine = getProtectionLineFromCart(updatedCart, protectionProductId);
      var updatedCartTotal = getCartTotalForProtection(updatedCart, protectionProductId);
      var updatedTargetVariant = findProtectionVariant(updatedCartTotal, config.variants) || targetVariant;

      updateProtectionBlockData(drawer, updatedCartTotal, updatedProtectionLine, updatedTargetVariant);
      return updatedCart;
    } catch (error) {
      console.error(error);
      return cartContent;
    } finally {
      syncingProtection = false;
    }
  }

  function dispatchCartRefresh(cartContent, replacementDelay, options) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
      bubbles: true,
      detail: {
        cart: cartContent,
        replacementDelay: replacementDelay || 0,
        openMiniCart: false,
        protectionUpdate: !!(options && options.protectionUpdate),
        skipProtectionSync: !!(options && options.skipProtectionSync)
      }
    }));
  }

  async function refreshCart(cartContent, replacementDelay, options) {
    var drawer = document.getElementById('mini-cart');

    if (!(options && options.skipProtectionSync)) {
      setProtectionBlockLoading(drawer, true);
    }

    try {
      var syncedCart = await syncProtectionBeforeRender(cartContent, drawer, options);
      dispatchCartUpdated(syncedCart);
      dispatchCartRefresh(syncedCart, replacementDelay, Object.assign({}, options, {
        skipProtectionSync: true
      }));
    } catch (error) {
      console.error(error);
      dispatchCartUpdated(cartContent);
      dispatchCartRefresh(cartContent, replacementDelay, Object.assign({}, options, {
        skipProtectionSync: true
      }));
    }
  }

  function isOnlyProtectionInCart(cart, protectionProductId) {
    if (!cart || !cart.items || !cart.items.length || !protectionProductId) {
      return false;
    }

    return cart.items.every(function (item) {
      return item.product_id === protectionProductId;
    });
  }

  async function removeLoneProtectionProductIfNeeded() {
    if (removingLoneProtection) {
      return false;
    }

    var protectionProductId = window.themeVariables && window.themeVariables.settings && window.themeVariables.settings.protectionProductId;

    if (!protectionProductId) {
      return false;
    }

    var cartResponse = await fetch(window.themeVariables.routes.cartUrl + '.js', {
      credentials: 'same-origin'
    });

    if (!cartResponse.ok) {
      return false;
    }

    var cart = await cartResponse.json();

    if (!isOnlyProtectionInCart(cart, protectionProductId)) {
      return false;
    }

    var lineIndices = [];

    cart.items.forEach(function (item, index) {
      if (item.product_id === protectionProductId) {
        lineIndices.push(index + 1);
      }
    });

    removingLoneProtection = true;

    try {
      var updatedCart = cart;

      for (var i = lineIndices.length - 1; i >= 0; i--) {
        updatedCart = await removeProtectionLine(lineIndices[i]);
      }

      refreshCart(updatedCart, 0, { skipProtectionSync: true });
      return true;
    } catch (error) {
      console.error(error);
      return false;
    } finally {
      removingLoneProtection = false;
    }
  }

  async function mergeCartSections(responseJson) {
    var cartResponse = await fetch(window.themeVariables.routes.cartUrl + '.js', {
      credentials: 'same-origin'
    });
    var cartContent = await cartResponse.json();

    if (responseJson && responseJson.sections) {
      cartContent.sections = responseJson.sections;
    }

    return cartContent;
  }

  async function addProtectionVariant(variantId) {
    var response = await fetch(window.themeVariables.routes.cartAddUrl + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: ['mini-cart']
      })
    });

    var responseJson = await response.json();

    if (!response.ok) {
      throw new Error(responseJson.description || 'Unable to add shipping protection');
    }

    return mergeCartSections(responseJson);
  }

  async function removeProtectionLine(lineIndex) {
    var response = await fetch(window.themeVariables.routes.cartChangeUrl + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        line: lineIndex,
        quantity: 0,
        sections: ['mini-cart']
      })
    });

    var responseJson = await response.json();

    if (!response.ok) {
      throw new Error(responseJson.description || 'Unable to remove shipping protection');
    }

    return mergeCartSections(responseJson);
  }

  async function updateCartDiscounts(codes) {
    var discountValue = Array.isArray(codes) ? codes.join(',') : codes;

    var response = await fetch(window.themeVariables.routes.cartUrl + '/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        discount: discountValue,
        sections: ['mini-cart']
      })
    });

    var responseJson = await response.json();

    if (!response.ok) {
      throw new Error(responseJson.description || responseJson.message || 'Invalid discount code');
    }

    return responseJson;
  }

  function getAppliedDiscountCodes(drawer) {
    return Array.from(drawer.querySelectorAll('[data-discount-remove]')).map(function (button) {
      return button.getAttribute('data-discount-code');
    }).filter(Boolean);
  }

  function dispatchCartUpdated(cartContent) {
    document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
      bubbles: true,
      detail: {
        cart: cartContent
      }
    }));
  }

  var discountInputErrorTimeout = null;

  function isDiscountCodeApplied(cartContent, code) {
    if (!cartContent || !Array.isArray(cartContent.discount_codes)) {
      return false;
    }

    var normalizedCode = String(code).toLowerCase();

    return cartContent.discount_codes.some(function (discountCode) {
      return discountCode.code
        && discountCode.code.toLowerCase() === normalizedCode
        && discountCode.applicable !== false;
    });
  }

  function getDiscountInputWrap(drawer) {
    return drawer ? drawer.querySelector('[data-discount-block] .mini-cart__discount-input') : null;
  }

  function setDiscountInputLoading(drawer, isLoading) {
    var inputWrap = getDiscountInputWrap(drawer);
    var loader = inputWrap ? inputWrap.querySelector('.mini-cart__discount-input-loader') : null;

    if (!inputWrap || !loader) {
      return;
    }

    if (isLoading) {
      hideDiscountInputError(drawer);
    }

    inputWrap.classList.toggle('is-loading', isLoading);
    inputWrap.setAttribute('aria-busy', isLoading ? 'true' : 'false');
    loader.hidden = !isLoading;
  }

  function hideDiscountInputError(drawer) {
    var inputWrap = getDiscountInputWrap(drawer);
    var errorNode = inputWrap ? inputWrap.querySelector('.mini-cart__discount-input-error') : null;

    if (discountInputErrorTimeout) {
      clearTimeout(discountInputErrorTimeout);
      discountInputErrorTimeout = null;
    }

    if (!inputWrap || !errorNode) {
      return;
    }

    inputWrap.classList.remove('has-error');
    errorNode.setAttribute('hidden', '');
  }

  function showDiscountInputError(drawer) {
    var inputWrap = getDiscountInputWrap(drawer);
    var errorNode = inputWrap ? inputWrap.querySelector('.mini-cart__discount-input-error') : null;

    if (!inputWrap || !errorNode) {
      return;
    }

    if (discountInputErrorTimeout) {
      clearTimeout(discountInputErrorTimeout);
      discountInputErrorTimeout = null;
    }

    inputWrap.classList.remove('is-loading');
    inputWrap.classList.add('has-error');
    errorNode.removeAttribute('hidden');

    var loader = inputWrap.querySelector('.mini-cart__discount-input-loader');
    if (loader) {
      loader.setAttribute('hidden', '');
    }

    discountInputErrorTimeout = window.setTimeout(function () {
      hideDiscountInputError(drawer);
    }, 2500);
  }

  function showDiscountMessage(drawer, message, isError) {
    var messageNode = drawer.querySelector('[data-discount-message]');

    if (!messageNode) {
      return;
    }

    messageNode.textContent = message;
    messageNode.hidden = false;
    messageNode.classList.toggle('mini-cart__discount-message--error', !!isError);
  }

  function clearDiscountMessage(drawer) {
    var messageNode = drawer.querySelector('[data-discount-message]');

    if (!messageNode) {
      return;
    }

    messageNode.textContent = '';
    messageNode.hidden = true;
    messageNode.classList.remove('mini-cart__discount-message--error');
  }

  async function handleDiscountApply(drawer) {
    var input = drawer.querySelector('[data-discount-input]');
    var applyButton = drawer.querySelector('[data-discount-apply]');

    if (!input || !applyButton) {
      return;
    }

    var code = input.value.trim();

    if (!code) {
      return;
    }

    var existingCodes = getAppliedDiscountCodes(drawer);

    if (existingCodes.some(function (existingCode) {
      return existingCode.toLowerCase() === code.toLowerCase();
    })) {
      showDiscountMessage(drawer, 'Discount code already applied', true);
      showDiscountInputError(drawer);
      return;
    }

    applyButton.disabled = true;
    clearDiscountMessage(drawer);
    setDiscountInputLoading(drawer, true);

    try {
      var cartContent = await updateCartDiscounts(existingCodes.concat([code]));

      if (!isDiscountCodeApplied(cartContent, code)) {
        throw new Error('Invalid discount code');
      }

      input.value = '';
      hideDiscountInputError(drawer);
      await refreshCart(cartContent, 0);
    } catch (error) {
      showDiscountMessage(drawer, error.message || 'Invalid discount code', true);
      showDiscountInputError(drawer);
    } finally {
      applyButton.disabled = false;
      setDiscountInputLoading(drawer, false);
    }
  }

  async function handleDiscountRemove(drawer, removeButton) {
    var codeToRemove = removeButton.getAttribute('data-discount-code');

    if (!codeToRemove) {
      return;
    }

    removeButton.disabled = true;
    clearDiscountMessage(drawer);

    try {
      var remainingCodes = getAppliedDiscountCodes(drawer).filter(function (code) {
        return code !== codeToRemove;
      });
      var cartContent = await updateCartDiscounts(remainingCodes);
      await refreshCart(cartContent, 0);
    } catch (error) {
      showDiscountMessage(drawer, error.message || 'Unable to remove discount code', true);
      removeButton.disabled = false;
    }
  }

  async function addUpsellVariant(variantId) {
    var response = await fetch(window.themeVariables.routes.cartAddUrl + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify({
        items: [{ id: Number(variantId), quantity: 1 }],
        sections: ['mini-cart']
      })
    });

    var responseJson = await response.json();

    if (!response.ok) {
      throw new Error(responseJson.description || 'Unable to add product');
    }

    return mergeCartSections(responseJson);
  }

  function updateUpsellAddButton(card, selected) {
    var addButton = card ? card.querySelector('[data-upsell-add-btn]') : null;

    if (!addButton) {
      return;
    }

    addButton.disabled = !selected || selected.available === false;
  }

  function updateUpsellFrameProductDisplay(card, selected) {
    if (!card || !selected) {
      return;
    }

    var titleNode = card.querySelector('.mini-cart-upsell-card__title');
    var descNode = card.querySelector('.mini-cart-upsell-card__desc');
    var imageNode = card.querySelector('.mini-cart-upsell-card__image');
    var mediaNode = card.querySelector('.mini-cart-upsell-card__media');

    if (titleNode && selected.title) {
      titleNode.textContent = selected.title;
    }

    if (descNode) {
      descNode.textContent = selected.description || '';
      descNode.hidden = !selected.description;
    }

    if (!selected.imageUrl || !mediaNode) {
      return;
    }

    if (imageNode && imageNode.tagName === 'IMG') {
      imageNode.src = selected.imageUrl;
      imageNode.removeAttribute('srcset');
      return;
    }

    var newImage = document.createElement('img');
    newImage.className = 'mini-cart-upsell-card__image';
    newImage.loading = 'lazy';
    newImage.sizes = '140px';
    newImage.src = selected.imageUrl;

    if (imageNode) {
      imageNode.replaceWith(newImage);
    } else {
      mediaNode.appendChild(newImage);
    }
  }

  function handleUpsellOptionClick(button) {
    var card = button.closest('[data-upsell-card]');
    var form = button.closest('[data-upsell-card]');
    var variantInput = form ? form.querySelector('[data-upsell-variant-input]') : null;
    var priceNode = card ? card.querySelector('[data-upsell-price]') : null;
    var options = [];
    var currentIndex = parseInt(button.dataset.currentIndex || '0', 10);

    if (button.dataset.upsellMode === 'frame-products') {
      options = JSON.parse(button.dataset.upsellFrameProducts || '[]');
    } else if (button.dataset.upsellMode === 'variants') {
      options = JSON.parse(button.dataset.upsellVariants || '[]');
    }

    if (!options.length || !variantInput) {
      return;
    }

    currentIndex = (currentIndex + 1) % options.length;
    button.dataset.currentIndex = String(currentIndex);

    var selected = options[currentIndex];
    variantInput.value = selected.id;
    button.textContent = selected.label;

    if (priceNode && typeof selected.price === 'number') {
      priceNode.textContent = formatMoney(selected.price);
    }

    if (button.dataset.upsellMode === 'frame-products') {
      updateUpsellFrameProductDisplay(card, selected);
    }

    updateUpsellAddButton(card, selected);
  }

  function updateProtectionPriceDisplay(drawer) {
    var config = getProtectionConfig(drawer);
    var priceNode = drawer ? drawer.querySelector('[data-protection-price]') : null;

    if (!config || !priceNode || config.enabled) {
      return;
    }

    var variant = findProtectionVariant(config.cartTotal, config.variants);

    if (variant) {
      priceNode.textContent = formatMoney(variant.price);
    }
  }

  async function handleProtectionToggle(toggle, drawer) {
    var config = getProtectionConfig(drawer);

    if (!config || !toggle) {
      if (toggle) {
        toggle.checked = !toggle.checked;
      }
      return;
    }

    setProtectionBlockLoading(drawer, true);
    toggle.disabled = true;

    try {
      if (toggle.checked) {
        var variant = findProtectionVariant(config.cartTotal, config.variants);

        if (!variant || !variant.available) {
          toggle.checked = false;
          setProtectionBlockLoading(drawer, false);
          return;
        }

        var addResponse = await addProtectionVariant(variant.id);
        await refreshCart(addResponse, 0, { protectionUpdate: true, skipProtectionSync: true });
        return;
      }

      var protectionProductId = getProtectionProductId();
      var lineIndex = config.lineIndex;
      var cartResponse = await fetch(window.themeVariables.routes.cartUrl + '.js', {
        credentials: 'same-origin'
      });

      if (cartResponse.ok) {
        var currentCart = await cartResponse.json();
        var protectionLine = getProtectionLineFromCart(currentCart, protectionProductId);

        if (protectionLine) {
          lineIndex = protectionLine.lineIndex;
        }
      }

      if (lineIndex) {
        var removeResponse = await removeProtectionLine(lineIndex);
        await refreshCart(removeResponse, 0, { protectionUpdate: true, skipProtectionSync: true });
        return;
      }

      toggle.checked = false;
      setProtectionBlockLoading(drawer, false);
    } catch (error) {
      toggle.checked = !toggle.checked;
      setProtectionBlockLoading(drawer, false);
    } finally {
      toggle.disabled = false;
    }
  }

  async function handleUpsellAddClick(button) {
    var card = button.closest('[data-upsell-card]');
    var variantInput = card ? card.querySelector('[data-upsell-variant-input]') : null;

    if (!variantInput || !variantInput.value || button.disabled) {
      return;
    }

    button.disabled = true;

    if (typeof window.showMiniCartContentLoader === 'function') {
      window.showMiniCartContentLoader(document.getElementById('mini-cart'));
    }

    try {
      var cartContent = await addUpsellVariant(variantInput.value);
      await refreshCart(cartContent, 0);
    } catch (error) {
      if (typeof window.finishMiniCartLoading === 'function') {
        window.finishMiniCartLoading();
      }
      button.disabled = false;
    }
  }

  function setLineItemControlLoading(block, isLoading) {
    if (!block) {
      return;
    }

    block.classList.toggle('is-loading', isLoading);
    block.setAttribute('aria-busy', isLoading ? 'true' : 'false');

    var loader = block.querySelector('.mini-cart-line-item__control-loader');

    if (loader) {
      loader.hidden = !isLoading;
    }
  }

  function showLineItemControlLoadingFromEvent(event) {
    var qtyButton = event.target.closest('.mini-cart-qty__btn:not(.is-disabled)');

    if (qtyButton) {
      setLineItemControlLoading(qtyButton.closest('.mini-cart-qty'), true);
      return;
    }

    var removeButton = event.target.closest('.mini-cart-line-item__remove');

    if (removeButton) {
      setLineItemControlLoading(removeButton, true);
    }
  }

  function clearLineItemControlLoading(lineItemQuantity) {
    if (!lineItemQuantity) {
      return;
    }

    lineItemQuantity.querySelectorAll('.mini-cart-qty.is-loading, .mini-cart-line-item__remove.is-loading').forEach(function (block) {
      setLineItemControlLoading(block, false);
    });
  }

  function initMiniCartDrawer(drawer) {
    if (!drawer) {
      return;
    }

    if (drawer.dataset.miniCartBound !== 'true') {
      drawer.dataset.miniCartBound = 'true';

      drawer.addEventListener('click', function (event) {
        var toggleLabel = event.target.closest('.mini-cart__protection-toggle');

        if (toggleLabel) {
          var protectionToggle = toggleLabel.querySelector('[data-protection-toggle]');

          if (protectionToggle && !protectionToggle.disabled) {
            event.preventDefault();
            protectionToggle.checked = !protectionToggle.checked;
            handleProtectionToggle(protectionToggle, drawer);
          }

          return;
        }

        var qtyButton = event.target.closest('.mini-cart-qty__btn:not(.is-disabled)');
        var removeLineItemButton = event.target.closest('.mini-cart-line-item__remove');

        if (qtyButton || removeLineItemButton) {
          showLineItemControlLoadingFromEvent(event);
        }

        var optionButton = event.target.closest('[data-upsell-option-btn]');

        if (optionButton) {
          event.preventDefault();
          handleUpsellOptionClick(optionButton);
          return;
        }

        var addButton = event.target.closest('[data-upsell-add-btn]');

        if (addButton) {
          event.preventDefault();
          handleUpsellAddClick(addButton);
          return;
        }

        if (event.target.closest('[data-discount-apply]')) {
          event.preventDefault();
          handleDiscountApply(drawer);
          return;
        }

        var removeButton = event.target.closest('[data-discount-remove]');

        if (removeButton) {
          event.preventDefault();
          handleDiscountRemove(drawer, removeButton);
        }
      });

      drawer.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          var toggleLabel = event.target.closest('.mini-cart__protection-toggle');

          if (toggleLabel) {
            event.preventDefault();
            var protectionToggle = toggleLabel.querySelector('[data-protection-toggle]');

            if (protectionToggle && !protectionToggle.disabled) {
              protectionToggle.checked = !protectionToggle.checked;
              handleProtectionToggle(protectionToggle, drawer);
            }

            return;
          }
        }

        if (event.key === 'Enter' && event.target.matches('[data-discount-input]')) {
          event.preventDefault();
          handleDiscountApply(drawer);
        }
      });

      drawer.addEventListener('change', function (event) {
        if (event.target.matches('.mini-cart-qty__input')) {
          setLineItemControlLoading(event.target.closest('.mini-cart-qty'), true);
        }
      });

      drawer.addEventListener('line-item-quantity:change:end', function (event) {
        if (event.detail && event.detail.cart) {
          return;
        }

        clearLineItemControlLoading(event.target);
      });
    }

    updateProtectionPriceDisplay(drawer);
  }

  document.addEventListener('DOMContentLoaded', function () {
    removeLoneProtectionProductIfNeeded().then(function (removed) {
      if (!removed) {
        initMiniCartDrawer(document.getElementById('mini-cart'));
      }
    });
  });

  document.documentElement.addEventListener('cart:refresh', function (event) {
    if (event.detail && event.detail.skipProtectionSync) {
      return;
    }

    if (!event.detail || !event.detail.cart) {
      return;
    }

    event.stopImmediatePropagation();

    var originalDetail = event.detail;
    var drawer = document.getElementById('mini-cart');

    setProtectionBlockLoading(drawer, true);

    syncProtectionBeforeRender(originalDetail.cart, drawer).then(function (syncedCart) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:updated', {
        bubbles: true,
        detail: {
          cart: syncedCart
        }
      }));

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: Object.assign({}, originalDetail, {
          cart: syncedCart,
          skipProtectionSync: true,
          replacementDelay: 0
        })
      }));
    }).catch(function (error) {
      console.error(error);

      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: Object.assign({}, originalDetail, {
          skipProtectionSync: true,
          replacementDelay: 0
        })
      }));
    });
  }, true);

  document.documentElement.addEventListener('cart:refresh', function (event) {
    window.requestAnimationFrame(function () {
      removeLoneProtectionProductIfNeeded().then(function (removed) {
        if (removed) {
          return;
        }

        var drawer = document.getElementById('mini-cart');
        initMiniCartDrawer(drawer);

        if (event.detail && (event.detail.skipProtectionSync || event.detail.protectionUpdate)) {
          setProtectionBlockLoading(drawer, false);
        }

        if (event.detail && event.detail.protectionUpdate) {
          var replacementDelay = event.detail.replacementDelay || 0;
          window.setTimeout(function () {
            setProtectionBlockLoading(drawer, false);
          }, replacementDelay + 50);
        }
      });
    });
  });
})();
